import React from "react";

const HowItWorks = ({ data }) => {
  const { mainHeading, subheading, sectionTitle, whySection } = data;

  return (
    <section className="pt-sp-100 sm:pt-sp-big bg-white">
     
      <div className="container mx-auto px-3 text-center">
      {mainHeading &&
        <h2 className="text-heading text-baseBlack mb-2 sm:text-lg">
          {mainHeading}
        </h2>}
        {subheading &&
        <p className="text-base2 font-medium mb-5 text-baseBlack sm:text-base">
          {subheading}
        </p>}
        <h3 className="text-textxl font-medium text-baseBlack mb-6 sm:text-xl">
          {sectionTitle}
        </h3>

        <div className="flex flex-wrap justify-between items-start relative">
          {whySection.map((item, index) => (
            <div
              key={item.id}
              className="flex flex-col items-center text-center w-[20%] sm:w-full sm:mb-[68px] relative"
            >
              <div
                className="w-6 h-6 flex items-center justify-center rounded-xl text-white font-semibold text-base2"
                style={{ backgroundColor: item.color }}
              >
                {item.id}
              </div>

              {index !== whySection.length - 1 && (
                <>
                  <span className="absolute top-2 right-12 w-1 h-1 bg-[#F5681D] rounded-full sm:hidden"></span>
                  <div
                    className="absolute top-3 border-t-2 border-dashed border-[#C4C4C4] sm:hidden"
                    style={{
                      left: "calc(100% - 45px)",
                      width: "105px",
                    }}
                  />
                </>
              )}

              <p className="mt-5 mb-5 sm:mt-2 sm:mb-0 text-baseBlack font-medium text-base2 sm:text-base max-w-[180px]">
                {item.text}
              </p>
              {index !== whySection.length - 1 && (
                <>
                  <span className="hidden sm:block absolute top-28 w-1 h-1 bg-[#F5681D] rounded-full"></span>
                    <div className="hidden sm:block absolute left-1/2 top-[124px] border-l-2 border-dashed border-[#C4C4C4] h-6 -translate-x-1/2" />
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
